var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThyroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 526 525",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.998 330.581L453.375 294.962C466.043 268.992 466.043 238.417 453.375 212.448L435.998 176.822V61.5024H166.001V176.822L148.623 212.44C135.956 238.41 135.956 268.985 148.623 294.954L166.001 330.58L149.306 369.943C136.039 401.225 136.039 436.751 149.306 468.034L166.001 507.404H435.998L452.693 468.041C465.959 436.759 465.959 401.232 452.693 369.95L435.998 330.581Z",
    fill: "#FDD2B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5 215.261H293.5V230.637H308.5V215.261Z",
    fill: "#F6BB92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.001 207.574H91.0018C86.8622 207.574 83.5022 204.137 83.5022 199.886C83.5022 195.634 86.8622 192.198 91.0018 192.198H121.001C125.141 192.198 128.501 195.634 128.501 199.886C128.501 204.137 125.142 207.574 121.001 207.574Z",
    fill: "#EA9D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 230.637C104.081 230.637 102.161 229.884 100.699 228.385L78.1992 205.321C75.2663 202.315 75.2663 197.456 78.1992 194.451L100.699 171.387C103.632 168.38 108.372 168.38 111.304 171.387C114.237 174.393 114.237 179.252 111.304 182.257L94.1063 199.886L111.304 217.514C114.237 220.521 114.237 225.38 111.304 228.385C109.842 229.884 107.922 230.637 106.001 230.637Z",
    fill: "#EA9D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M510.997 207.574H480.997C476.858 207.574 473.498 204.137 473.498 199.886C473.498 195.634 476.858 192.198 480.997 192.198H510.997C515.136 192.198 518.496 195.634 518.496 199.886C518.497 204.137 515.137 207.574 510.997 207.574Z",
    fill: "#EA9D2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.998 230.637C494.077 230.637 492.158 229.884 490.695 228.385C487.762 225.379 487.762 220.52 490.695 217.514L507.893 199.886L490.695 182.257C487.762 179.251 487.762 174.392 490.695 171.387C493.628 168.38 498.368 168.38 501.3 171.387L523.8 194.451C526.733 197.457 526.733 202.316 523.8 205.321L501.3 228.385C499.838 229.884 497.917 230.637 495.998 230.637Z",
    fill: "#EA9D2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.235 503.987C319.198 472.041 469.198 452.565 436.661 506.893H305.411L163.684 509.456C167.551 524.32 148.571 451.374 163.684 509.456L131.698 413.295L156.517 324.628H456.514L469.198 423.546L436.661 506.893C451.773 448.803 378.011 506.893 436.661 506.893C458.72 510.994 314.235 492.446 314.235 503.987Z",
    fill: "#428DC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThyroid);
export default __webpack_public_path__ + "static/media/thyroid.4e3365a950282149d70e18f2ad0f53e9.svg";
export { ForwardRef as ReactComponent };